export const wizardOptions = {
  defaultPages: [   
    'VehiclesNumberPage',
    'HomeownerPage',
    'AgePage',
    'InsuredPage',
    'InsuranceProviderPage',
    'CreditScorePage',
    'ZipCodePage',
    'MemberPage',    
  ],
  onlyZipPages: [    
    'ZipCodePage',      
  ],
};

export const wizardData = [

  {
    formPageName: 'VehiclesNumberPage',
    formNumber: 0,
    formType: 'radioWithIcon',
    questionTitle: 'How many vehicles are you insuring today?',
    questionDescription: '',
    inputName: 'multipleCar',
    selectedOption: '',
    questionOptions: [
      {
        id: 1,
        title: '1',
        value: '1',
      },
      {
        id: 2,
        title: '2',
        value: '2',
      },
      {
        id: 3,
        title: '3',
        value: '3',
      },
      {
        id: 4,
        title: '4+',
        value: '4',
      }
    ],
  },
  {
    formPageName: 'HomeownerPage',
    formNumber: 1,
    formType: 'radioWithIcon',
    questionTitle: 'Are you a homeowner?',
    selectedOption: '',
    scrollable: true,
    inputName: 'homeowner',
    questionOptions: [
      {
        id: 1,
        title: 'Yes',
        value: 'Yes',
      },
      {
        id: 2,
        title: 'No',
        value: 'No',
      }
    ],
  },
  {
    formPageName: 'AgePage',
    formNumber: 2,
    formType: 'radioWithIcon',
    questionTitle: 'How old are you?',
    selectedOption: '',
    scrollable: true,
    inputName: 'age',
    questionOptions: [
      {
        id: 1,
        title: '16-20',
        value: '16',
      },
      {
        id: 2,
        title: '21-24',
        value: '21',
      },
      {
        id: 3,
        title: '25-34',
        value: '25',
      },
      {
        id: 4,
        title: '35-44',
        value: '35',
      },
      {
        id: 5,
        title: '45-54',
        value: '45',
      },

      {
        id: 6,
        title: '55-64',
        value: '55',
      },
      {
        id: 7,
        title: '65+',
        value: '65',
      }
    ]
  },
  {
    formPageName: 'CreditScorePage',
    formNumber: 3,
    formType: 'radioWithIcon',
    questionTitle: 'What\'s your credit score?',
    selectedOption: '',
    scrollable: true,
    inputName: 'creditScore',
    questionOptions: [
      {
        id: 1,
        title: 'Excellent',
        value: '720',
      },
      {
        id: 2,
        title: 'Good',
        value: '660',
      },
      {
        id: 3,
        title: 'Fair',
        value: '600',
      },
      {
        id: 4,
        title: 'Poor',
        value: '0',
      }
    ],
  },
  {
    formPageName: 'InsuredPage',
    formNumber: 4,
    formType: 'radioWithIcon',
    questionTitle: 'Are you currently insured?',
    selectedOption: '',
    scrollable: true,
    inputName: 'insured',
    questionOptions: [
      {
        id: 1,
        title: 'Yes',
        value: 'Yes',
      },
      {
        id: 2,
        title: 'No',
        value: 'No',
      }
    ],
  },
  {
    formPageName: 'InsuranceProviderPage',
    formNumber: 4,
    formType: 'select',
    questionTitle: 'Who is your current insurance provider?',
    selectedOption: 'Please select',
    scrollable: true,
    inputName: 'insuranceProvider',
    questionOptions: [
      { id: 1, title: 'Please select', value: 'Please select' },
      { id: 2, title: 'Not currently insured', value: 'Not currently insured' },
      { id: 3, title: '21st Century', value: '21st Century' },
      { id: 4, title: 'AAA', value: 'AAA' },
      { id: 5, title: 'Allstate', value: 'Allstate' },
      { id: 6, title: 'American Family', value: 'American Family' },
      { id: 7, title: 'Bristol West', value: 'Bristol West' },
      { id: 8, title: 'Cure', value: 'Cure' },
      { id: 9, title: 'Dairyland Insurance', value: 'Dairyland Insurance' },
      { id: 10, title: 'Direct General', value: 'Direct General' },
      { id: 11, title: 'Elephant', value: 'Elephant' },
      { id: 12, title: 'Erie Insurance', value: 'Erie Insurance' },
      { id: 13, title: 'Esurance', value: 'Esurance' },
      { id: 14, title: 'Farm Bureau/Farm Family/Rural', value: 'Farm Bureau/Farm Family/Rural' },
      { id: 15, title: 'Farmers', value: 'Farmers' },
      { id: 16, title: 'Farmers Insurance', value: 'Farmers Insurance' },
      { id: 17, title: 'Gainsco', value: 'Gainsco' },
      { id: 18, title: 'Geico', value: 'Geico' },
      { id: 19, title: 'Liberty Mutual', value: 'Liberty Mutual' },
      { id: 20, title: 'Mercury', value: 'Mercury' },
      { id: 21, title: 'Nationwide', value: 'Nationwide' },
      { id: 22, title: 'Plymouth Rock', value: 'Plymouth Rock' },
      { id: 23, title: 'Progressive', value: 'Progressive' },
      { id: 24, title: 'Prudential', value: 'Prudential' },
      { id: 25, title: 'SafeAuto', value: 'SafeAuto' },
      { id: 26, title: 'Safeco', value: 'Safeco' },
      { id: 27, title: 'State Farm', value: 'State Farm' },
      { id: 28, title: 'The General', value: 'The General' },
      { id: 29, title: 'The Hartford', value: 'The Hartford' },
      { id: 30, title: 'Travelers', value: 'Travelers' },
      { id: 31, title: 'USAA', value: 'USAA' },
      { id: 32, title: 'Other', value: 'Other' },
    ],
  },
  {
    formPageName: 'ZipCodePage',
    formNumber: 4,
    formType: 'input',    
    questionTitle: "What\'s your zip code?",
    valueType: 'number',
    writtenAnswers: {
      zipcode: '',
    },
    inputs: [
      {
        validationType: 'zipCode',
        inputId: 'zipcode',
        inputLabel: 'Enter Zip Code',
        inputValue: '',
        isSmall: false,           
      },
    ],
    inputDescription:
      '',
  },
  {
    formPageName: 'MemberPage',
    formNumber: 4,
    formType: 'radioWithIcon',
    questionTitle: 'Are either you or your spouse an active member, or an honorably discharged veteran of the US military?',
    questionDescription: '',
    selectedOption: '',
    scrollable: true,
    inputName: 'member',
    questionOptions: [
      {
        id: 1,
        title: 'Yes',
        value: 'Yes',
      },
      {
        id: 2,
        title: 'No',
        value: 'No',
      }
    ],
  },
];
